<template>
    <TVJoyDialog :pattern-brand="true" pattern-confirm>
        <template #dialog-header>{{ $t('projectclient.quote.view.quote-summary.dialog.accept.title') }}</template>
        <template #dialog-body>
            <p class="modal__description">{{ $t('projectclient.quote.view.quote-summary.dialog.accept.description', [freelancerName]) }}</p>

            <MaltIllustration name="rocket-launch--high" alt="" width="190" />
        </template>

        <template #dialog-confirm>
            <VJoyButton variant="main" data-testid="quote-accepted-dialog-confirm" @click="redirect">
                {{ $t('projectclient.quote.view.quote-summary.dialog.accept.confirm') }}
            </VJoyButton>
        </template>
    </TVJoyDialog>
</template>

<script setup lang="ts">
    import {navigateTo} from '@typed-router';
    import {MaltIllustration} from '#components';
    import {VJoyButton} from '@maltjoy/core-vue';
    import {useDialogRoot} from '~/common/composables';

    const {TVJoyDialog, confirmDialog} = useDialogRoot();

    const props = defineProps<{
        freelancerName: string;
        projectId?: string;
    }>();

    async function redirect() {
        confirmDialog();
        if (props.projectId) {
            await navigateTo({name: 'project-projectId-index-activity', params: {projectId: props.projectId}});
        } else {
            await navigateTo({name: 'index'});
        }
    }
</script>

<style lang="scss" scoped>
    .modal {
        &__description {
            margin-bottom: var(--joy-core-spacing-8);
        }
    }
</style>
